import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    alignSelf: 'flex-start'
  },
  switchControlLabel: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    padding: '0px',
    margin: '0px',
    marginBottom: '16px',
    '& input': {
      display: 'none'
    }
  },
  startingPageNumberContainer: {
    alignSelf: 'flex-start',
    '& .MuiOutlinedInput-root': {
      margin: 0,
      padding: 0,
      width: '100%',
      textTransform: 'capitalize',
      '& .MuiOutlinedInput-input, & .MuiInputBase-input': {
        padding: '0px 8px',
        height: '32px ',
        minHeight: '32px ',
        maxHeight: '32px',
        border: 'none'
      },
      '&.Mui-focused .MuiOutlinedInput-input, &.Mui-focused .MuiInputBase-input': {
        padding: '0px 8px',
        height: '32px',
        minHeight: '32px',
        maxHeight: '32px'
      },
      '& .MuiInputLabel-root': {
        fontWeight: capitalDesignTokens.foundations.typography.fontWeight.normal
      }
    },
    '& .MuiInputBase-input': {
      padding: '0px 8px',
      height: '32px',
      minHeight: '32px',
      maxHeight: '32px',
      border: 'none',
      '& .MuiOutlinedInput-input, & .MuiInputBase-input': {
        padding: '0px 8px'
      },
      '&.Mui-focused .MuiOutlinedInput-input, &.Mui-focused .MuiInputBase-input': {
        padding: '0px 8px',
        height: '32px',
        minHeight: '32px',
        maxHeight: '32px',
        border: 'none'
      }
    },
    '& .MuiFormLabel-root': {
      fontWeight: capitalDesignTokens.foundations.typography.fontWeight.normal
    }
  }
});
